<template>
<v-row>
    <v-form v-model="valid" style="width: 100%">
        <v-col cols="12" md="8" offset-md="2">
            <v-alert outlined type="info" text class="pa-2">
                <template v-slot:prepend>
                    <v-icon size="24" color="blue" class="mr-2">info</v-icon>
                </template>
                <span>
                    In acest pas, va rugam sa introduceti informatiile reale, referitoare la datele financiare a societatii dumneavoastra, necesare pentru generarea contractului de colaborare.
                    Pentru a trece in pasul urmator, completati toate campurile si apasati butonul "Urmatorul pas"
                </span>
            </v-alert>
            <v-text-field class="px-2" label="Numele societatii" v-model="organization.name" :rules="rules.name" required />
            <div class="">Date financiare ale societatii comerciale</div>
            <v-row>
                <v-col md="6" cols="12" class="py-0">
                    <v-text-field label="Cod fiscal" v-model="billing.fiscal_code" :rules="rules.fiscal_code" required />
                </v-col>
                <v-col md="6" cols="12" class="py-0">
                    <v-text-field label="Nr registrului" v-model="billing.registry_number" :rules="rules.registry_number" required />
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="12" md="8" offset-md="2">
            <div>Adresa</div>
            <v-row>
                <v-col class="py-0" cols="6" md="4">
                    <v-text-field label="Judet" v-model="organization.address.region" required :rules="rules.address_region" />
                </v-col>
                <v-col class="py-0" cols="6" md="4">
                    <v-text-field label="Localitate" v-model="organization.address.city" :rules="rules.address_city" required />
                </v-col>
                <v-col class="py-0" cols="9" md="3">
                    <v-text-field label="Strada" v-model="organization.address.street" :rules="rules.address_street" required />
                </v-col>
                <v-col class="py-0" cols="3" md="1">
                    <v-text-field label="Nr" v-model="organization.address.number" :rules="rules.address_number" />
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="12" md="8" offset-md="2">
            <div class="pb-2">
                Detalii bancare
                <span class="faded px-1">(date optionale)</span>
            </div>
            <v-row wrap v-for="(bank, index) in billing.banks" :key="index">
                <v-col cols="6" class="py-0">
                    <v-text-field v-model="bank.name" class="ma-0 pa-0" label="Numele bancii" :rules="rule_bank" />
                </v-col>
                <v-col cols="4" class="py-0">
                    <v-text-field v-model="bank.account" class="ma-0  pa-0" label="IBAN" :rules="rule_bank" />
                </v-col>
                <v-col cols="2" class="py-0">
                    <v-select class="ma-0 pa-0" :items="currencies" v-model="bank.currency" label="Moneda" clearable :rules="rule_bank" />
                </v-col>
            </v-row>
        </v-col>
    </v-form>
    <v-col cols="12" class="py-0">
        <div class="px-2 py-2 d-flex justify-space-between">
            <v-btn color="primary" outlined :small="$vuetify.breakpoint.smAndDown" @click="prevStep()">
                <v-icon size="16" color="primary">arrow_back_ios</v-icon>
                <span v-if="$vuetify.breakpoint.smAndUp">Pasul anterior</span>
                <span v-else>Inapoi</span>
            </v-btn>
            <div class="">
                <v-tooltip bottom :disabled="valid">
                    <template v-slot:activator="{ on }">
                        <div class="" v-on="on">
                            <v-btn class="mx-1" color="primary" :small="$vuetify.breakpoint.smAndDown" :disabled="!valid" @click="nextStep()">
                                <span v-if="$vuetify.breakpoint.smAndUp">Urmatorul pas</span>
                                <span v-else>Inainte</span>
                                <v-icon size="16" color="white">arrow_forward_ios</v-icon>
                            </v-btn>
                        </div>
                    </template>
                    <span>Toate campurile sunt obligatorii</span>
                </v-tooltip>
            </div>
        </div>
    </v-col>
</v-row>
</template>
<script>
export default {
    name: 'OrganizationRegistration',

    props: {
        organization: {
            type: Object,
        },
        billing: {
            type: Object,
        },
    },
    data() {
        return {
            valid: null,
            currencies: ["RON", "USD", "EUR"],
        }
    },
    computed: {
        rules() {
            return {
                name: [v => !!v || "Numele societatii este obligatoriu"],
                address_city: [v => !!v || this.$t('hotel.geolocation.form_rules.city')],
                address_region: [v => !!v || this.$t('hotel.geolocation.form_rules.state')],
                fiscal_code: [v => !!v || "Codul fiscal este obligatoriu"],
                registry_number: [v => !!v || "Nr registrului comertului este obligatoriu"],

            }
        },
        rule_bank() {
            if(!this.billing.banks[0].name && !this.billing.banks[0].account && !this.billing.banks[0].account) {
                return []
            } else {

                return [v => !!v || "Detalii bancare obligatorii"]
            }
        }
    },

    created() {},

    methods: {

        nextStep() {
            this.$emit('next');
        },

        prevStep() {
            this.$emit('prev');
        }
    },
}
</script>
